import Cookies from 'js-cookie';
import { config } from '../config';

type CookieOptions = {
  expires?: number | Date
  path?: string
  domain?: string
  secure?: boolean
};

const identifier = config.IDENTIFIER;

export function getIdentifier (key: string) {
  return `${identifier}.storage.${key}`;
}

export interface StorageError {
  error: Error
}

function setStorage (storage: Storage, key: string, value: any) {
  try {
    storage.setItem(getIdentifier(key), JSON.stringify(value));
    return true;
  } catch (error) {
    if (config.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('Error serializing value', error);
    }
    throw error;
  }
}

function getStorage (storage: Storage, key: string) {
  try {
    const cached = storage.getItem(getIdentifier(key));
    return JSON.parse(cached as string);
  } catch (error) {
    if (config.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('Error serializing value', error);
    }
    throw error;
  }
}

export const storage = {
  setLocal (key: string, value: string) {
    return setStorage(window.localStorage, key, value);
  },
  
  getLocal (key: string) {
    return getStorage(window.localStorage, key);
  },
  
  removeLocal (key: string) {
    return localStorage.removeItem(getIdentifier(key));
  },
  
  clearLocal () {
    return localStorage.clear();
  },
  
  setSession (key: string, value: string) {
    return setStorage(window.sessionStorage, key, value);
  },
  
  getSession (key: string) {
    return getStorage(window.sessionStorage, key);
  },
  
  removeSession (key: string) {
    return sessionStorage.removeItem(getIdentifier(key));
  },
  
  clearSession () {
    return sessionStorage.clear();
  },
  
  setCookie (key: string, value: string, options?: CookieOptions) {
    try {
      Cookies.set(getIdentifier(key), value, options);
      return true;
    } catch (error) {
      if (config.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn('Error serializing value', error);
      }
      return { error };
    }
  },
  
  getCookie (key: string) {
    try {
      const value = Cookies.get(getIdentifier(key));
      return value === undefined ? null : value;
    } catch (error) {
      if (config.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn('Error serializing value', error);
      }
      return { error };
    }
  },
  
  removeCookie (key: string, options?: CookieOptions) {
    Cookies.remove(getIdentifier(key), options);
  }
};

